import React from "react";
import Dropdown from "./Dropdown";

export const KEY_STATUS_OPTIONS = [
  { value: "active", label: "Active" },
  { value: "inactive", label: "Inactive" },
];

const KeyStatusFilter = ({ value, onValueChange }) => (
  <Dropdown
    value={value}
    onValueChange={onValueChange}
    size="default"
    options={KEY_STATUS_OPTIONS}
    className="w-[130px]"
  />
);

export default KeyStatusFilter;
